import React from 'react';

export interface AiInsightsIconProps {
  readonly color?: string;
  readonly width?: string | number;
  readonly height?: string | number;
}

const AiInsightsIcon: React.FC<AiInsightsIconProps> = ({ color = '#707374', width = '24', height = '24' }) => (
  <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M19.7498 17.25L22.4998 18.5L19.7498 19.75L18.4998 22.5L17.2498 19.75L14.4998 18.5L17.2498 17.25L18.4998 14.5L19.7498 17.25ZM19.9998 4C18.6683 7.27452 18.1636 10.1367 17.5134 12.5L15.6687 11.6602C15.7835 11.2279 15.8992 10.7609 16.0232 10.2549C16.2843 9.18933 16.572 7.99559 16.9519 6.70215C15.3718 7.07143 13.9637 7.45206 12.7195 7.87305C10.6286 8.58057 9.12954 9.35847 8.09155 10.2666C7.09871 11.1354 6.46788 12.1732 6.17944 13.5684C5.95468 14.6559 5.92802 16.0111 6.16968 17.7256C6.84224 17.6413 7.48217 17.5783 8.07788 17.5205L8.16675 17.5117C9.22126 17.4095 10.0969 17.3246 10.8835 17.1807L11.7458 19.0459C9.71901 19.4986 7.28574 19.4774 4.55151 20L4.44409 19.4863C2.30598 8.82469 7.94364 6.42552 19.9998 4ZM13.9373 13.0625L15.9998 14L13.9373 14.9375L12.9998 17L12.0623 14.9375L9.99976 14L12.0623 13.0625L12.9998 11L13.9373 13.0625Z'
      fill={color}
    />
  </svg>
);

export default AiInsightsIcon;
